<script lang="ts">
  import Loader from '$shared/atoms/Loader/Loader.svelte';

  interface Props {
    columnLength?: number;
    count?: number;
  }

  let { columnLength = 0, count = 0 }: Props = $props();
</script>

<tr>
  <td class="col-loader" colspan={columnLength}><Loader {count} /></td>
</tr>

<style>
  td.col-loader {
    padding: 16px 0;
  }
</style>
